<app-dialog-container
  title="{{ 'preview' | translate }} {{ data.attachment.name }}"
  confirmButtonText="{{ 'close' | translate }}"
  (confirmButtonHandler)="close()"
  [showCancelButton]="false"
>
  @if (isPdf) {
    <div class="loader" *appLoader="loading" [class.cdk-visually-hidden]="!loading"></div>
    <pdf-viewer
      [style.position]="loading ? 'absolute' : 'relative'"
      [class.cdk-visually-hidden]="loading"
      [src]="link | appendDomain"
      [original-size]="false"
      (after-load-complete)="loading = false"
    ></pdf-viewer>
  }
  @if (!isPdf) {
    <div class="preview-image-container">
      <img class="preview-image" [src]="link | appendDomain" alt="{{ data.attachment.name }}" />
    </div>
  }
</app-dialog-container>
